export default "__VITE_ASSET__iUHBW3gA__"